import type { Dispatch } from "redux";

import { groupCreationConstants } from "./types";

export const groupCreationShow = () => {
  return (dispatch: Dispatch) => {
    dispatch({ type: groupCreationConstants.GROUP_CREATION_SHOW });
  };
};

export const groupCreationHide = () => {
  return (dispatch: Dispatch) => {
    dispatch({ type: groupCreationConstants.GROUP_CREATION_HIDE });
  };
};
